(function (root, factory) {
  const popupConfig = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = popupConfig;
  }

  if (root) {
    root.WrPopupConfig = popupConfig;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const DISPLAY_OPTIONS = ['all', 'desktop', 'mobile'];

  function parseFormConfigs(value) {
    return String(value || '')
      .split(/\r?\n/)
      .map(function (line) {
        const parts = line.split('|');
        const formId = parts[0].trim();
        const requestedDisplay = (parts[1] || 'all').trim().toLowerCase();
        const displayOn = DISPLAY_OPTIONS.includes(requestedDisplay)
          ? requestedDisplay
          : 'all';

        return { formId, displayOn };
      })
      .filter(function (form) {
        return form.formId !== '';
      });
  }

  function selectFormId(forms, viewportWidth) {
    const isMobile = viewportWidth <= 768;
    const matchedForm = forms.find(function (form) {
      return form.displayOn === 'all'
        || (form.displayOn === 'mobile' && isMobile)
        || (form.displayOn === 'desktop' && !isMobile);
    });

    return matchedForm ? matchedForm.formId : null;
  }

  return {
    parseFormConfigs,
    selectFormId
  };
});
